<div class="top-bar">
  <div class="selection-container">
    <app-brands-selection-panel
      [isMyCompetitorsDisabled]="false"
      [shouldDisplayAddButton]="false"
      [shouldDisplayRemoveButton]="false"
      [myBrand]="myBrandItem"
      [myCompetitors]="myCompetitorsItems"
      [myBrandOptions]="myBrandOptions"
      [myCompetitorsOptions]="[]"
      (brandChanged)="onMyBrandChanged($event)">
    </app-brands-selection-panel>
  </div>
  <button class="demo-brands-button" *ngIf="showRibbonsAndBanner" (click)="onConnectClick()">
    Example brands — contact us to add yours
  </button>
</div>
<div class="second-bar social-page">
  <div class="filters-container">
    <div class="date-picker-disabled">
      <app-date-picker [range]="dateRangeGroup"></app-date-picker>
    </div>
  </div>
</div>
<div class="main-container">
  <div class="social-overview-screen">

  <!-- Hero Banner -->
  <div class="hero-banner">
    <div class="hero-content">
      <h1 class="hero-title">Social</h1>
      <p class="hero-subtitle">Analyze social reach, spend, and creative mix</p>
    </div>

    <!-- Glassmorphism stat badges -->
    <div class="hero-badge badge-cpm">
      <span class="badge-text">$2.15 CPM</span>
    </div>
    <div class="hero-badge badge-spend">
      <span class="badge-arrow">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 10L10 2M10 2H3M10 2V9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
      <span class="badge-text">+16% Spend</span>
    </div>
    <div class="hero-badge badge-impressions">
      <span class="badge-text">700K Impressions</span>
    </div>

    <!-- Decorative social icons -->
    <div class="hero-icon icon-search">
      <svg width="39" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,0.25)"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
    </div>
    <div class="hero-icon icon-share">
      <svg width="32" height="29" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
    </div>
    <div class="hero-icon icon-instagram-text">
      <span class="instagram-logotype">Instagram</span>
    </div>
    <div class="hero-icon icon-facebook">
      <svg width="77" height="62" viewBox="0 0 77 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M76.9946 23.5014C76.9946 42.9463 62.5814 59.0218 43.8574 61.6304C42.1067 61.8732 40.3155 62 38.4973 62C36.3986 62 34.3376 61.8328 32.3306 61.509C14.0005 58.5578 0 42.663 0 23.5014C0 2.2382 17.2376 -15 38.5 -15C59.7624 -15 77 2.2382 77 23.5014H76.9946Z" fill="#2154A6"/>
        <path d="M43.8568 15.9166V24.3037H54.2317L52.5889 35.6016H43.8568V61.6315C42.106 61.8743 40.3148 62.0011 38.4966 62.0011C36.3979 62.0011 34.337 61.8339 32.3299 61.5101V35.6016H22.7616V24.3037H32.3299V14.0417C32.3299 7.67512 37.4904 2.51175 43.8594 2.51175V2.51715C43.8783 2.51715 43.8945 2.51175 43.9134 2.51175H54.2344V12.2828H47.4904C45.4861 12.2828 43.8594 13.9095 43.8594 15.9139L43.8568 15.9166Z" fill="white"/>
      </svg>
    </div>
    <div class="hero-icon icon-instagram">
      <svg width="98" height="64" viewBox="0 0 98 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M49.1116 0H48.8884C21.8881 0 0 21.8881 0 48.8884V49.1116C0 76.1119 21.8881 98 48.8884 98H49.1116C76.1119 98 98 76.1119 98 49.1116V48.8884C98 21.8881 76.1119 0 49.1116 0Z" fill="url(#paint0_linear_15599_26064)"/>
        <path d="M64.1604 19.9394H33.8364C25.4589 19.9394 18.6436 26.7547 18.6436 35.1322V62.8743C18.6436 71.2518 25.4589 78.0671 33.8364 78.0671H64.1604C72.5379 78.0671 79.3532 71.2518 79.3532 62.8743V35.1322C79.3532 26.7547 72.5379 19.9394 64.1604 19.9394ZM24.0031 35.1322C24.0031 29.7109 28.4151 25.2989 33.8364 25.2989H64.1604C69.5817 25.2989 73.9937 29.7109 73.9937 35.1322V62.8743C73.9937 68.2956 69.5817 72.7075 64.1604 72.7075H33.8364C28.4151 72.7075 24.0031 68.2956 24.0031 62.8743V35.1322Z" fill="white"/>
        <path d="M49.0019 63.1322C56.7924 63.1322 63.1339 56.7941 63.1339 49.0002C63.1339 41.2064 56.7958 34.8683 49.0019 34.8683C41.2081 34.8683 34.87 41.2064 34.87 49.0002C34.87 56.7941 41.2081 63.1322 49.0019 63.1322ZM49.0019 40.2313C53.8396 40.2313 57.7743 44.166 57.7743 49.0036C57.7743 53.8413 53.8396 57.776 49.0019 57.776C44.1643 57.776 40.2296 53.8413 40.2296 49.0036C40.2296 44.166 44.1643 40.2313 49.0019 40.2313Z" fill="white"/>
        <path d="M64.4409 37.1512C66.5388 37.1512 68.2486 35.4448 68.2486 33.3435C68.2486 31.2423 66.5422 29.5359 64.4409 29.5359C62.3397 29.5359 60.6333 31.2423 60.6333 33.3435C60.6333 35.4448 62.3397 37.1512 64.4409 37.1512Z" fill="white"/>
        <defs>
          <linearGradient id="paint0_linear_15599_26064" x1="6.04661e-07" y1="15.3125" x2="79.625" y2="116.375" gradientUnits="userSpaceOnUse">
            <stop stop-color="#8E0EA4"/>
            <stop offset="0.274717" stop-color="#DA1385"/>
            <stop offset="0.530763" stop-color="#F12367"/>
            <stop offset="0.748824" stop-color="#FA6B39"/>
            <stop offset="1" stop-color="#FFB22E"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="hero-icon icon-heart">
      <svg width="30" height="30" viewBox="0 0 24 24" fill="rgba(255,255,255,0.15)"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
    </div>
    <div class="hero-icon icon-like">
      <svg width="36" height="31" viewBox="0 0 24 24" fill="rgba(255,255,255,0.25)"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg>
    </div>
  </div>

  <!-- Overview Section -->
  <section class="section">
    <h2 class="section-title">Overview</h2>
    <div class="overview-cards-row">
      <app-overview-card
        *ngFor="let card of overviewCards"
        [type]="CardType.SINGLE"
        [title]="card.title"
        [value]="card.value"
        [valueType]="card.valueType"
        [valueDescription]="card.description"
        [cardWidth]="'100%'">
      </app-overview-card>
    </div>
  </section>

  <!-- Creative Gallery -->
  <section class="section">
    <div class="widgets-wrapper">
      <div class="widget-container gallery">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container
          [title]="'Creative Gallery'"
          [control]="gallerySortControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="gallerySortOptions"
          [searchable]="false"
          [selectWidth]="'248px'"
          (apply)="onGallerySortChange()">
          <div class="gallery-grid">
            <div class="creative-card" *ngFor="let item of pagedCreatives">
              <!-- Top section: type + platform icons, then CPM + Impressions -->
              <div class="creative-top">
                <div class="creative-top-row">
                  <span class="creative-type-label">{{ item.type }}</span>
                  <div class="creative-platform-icons">
                    <svg *ngIf="hasFacebook(item.platform)" class="platform-icon" width="16" height="16" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                    <svg *ngIf="hasInstagram(item.platform)" class="platform-icon" width="16" height="16" viewBox="0 0 24 24" fill="#E4405F"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                  </div>
                </div>
                <div class="creative-metrics-row">
                  <span class="metric-pair"><span class="metric-lbl">CPM</span> <span class="metric-val">${{ item.cpm.toFixed(2) }}</span></span>
                  <span class="metric-pair"><span class="metric-lbl">Impressions</span> <span class="metric-val">{{ item.impressions }}</span></span>
                </div>
              </div>
              <!-- Middle section: creative image -->
              <div class="creative-image-wrapper">
                <img [src]="getCreativeImageUrl(item)" [alt]="item.brandName" class="creative-image" loading="lazy">
                <img *ngIf="isVideo(item)" class="video-play-button" [src]="'social-overview-assets/icons/videoPlayerIcon.svg' | assetVersion" alt="Play video">
              </div>
              <!-- Bottom section: brand chip + description -->
              <div class="creative-bottom">
                <div class="creative-brand-chip">
                  <img class="brand-chip-logo" [src]="getBrandLogoUrl(item.brandName)" [alt]="item.brandName">
                  <span class="brand-chip-name">{{ item.brandName }}</span>
                </div>
                <div class="creative-description">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </app-widget-container>
        <div class="paginator-container">
          <app-paginator #galleryPaginator
            [length]="sortedCreativeItems.length"
            [pageSize]="GALLERY_PAGE_SIZE"
            [initialPage]="1"
            (page)="onGalleryPageChange($event)">
          </app-paginator>
        </div>
      </div>
    </div>
  </section>

  <!-- Share of Voice + Performance Over Time -->
  <section class="section">
    <div class="widgets-wrapper">
      <div class="widget-container share-of-voice">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container
          [title]="'Share of Voice'"
          [control]="sovPlatformControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="sovPlatformOptions"
          [searchable]="false"
          [selectWidth]="'160px'"
          (apply)="onSovPlatformChange()">
          <app-pie-chart
            [data]="sovChartData"
            [colors]="sovColors"
            [isCompactMode]="true"
            [chartWidth]="388"
            format="percentage"
            valueField="share">
          </app-pie-chart>
        </app-widget-container>
      </div>
      <div class="widget-container performance-over-time">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container
          [title]="'Performance Over Time'"
          [control]="performanceMetricControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="performanceMetricOptions"
          [searchable]="false"
          [selectWidth]="'248px'"
          (apply)="onPerformanceMetricChange()">
          <app-performance-over-time
            [data]="performanceData"
            [brandColors]="brandColorsMap"
            valueField="value"
            [format]="performanceFormat">
          </app-performance-over-time>
        </app-widget-container>
      </div>
    </div>
  </section>

  <!-- Channel Distribution -->
  <section class="section">
    <div class="widgets-wrapper">
      <div class="widget-container full-width-social">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container [title]="'Channel Distribution by Spend'">
          <div class="chart-area">
            <highcharts-chart
              [Highcharts]="Highcharts"
              [options]="channelChartOptions"
              style="width: 100%; display: block;">
            </highcharts-chart>
          </div>
        </app-widget-container>
      </div>
    </div>
  </section>

  <!-- Ad Type -->
  <section class="section">
    <div class="widgets-wrapper">
      <div class="widget-container full-width-social">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container
          [title]="'Ad Type by Spend'"
          [control]="adTypePlatformControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="adTypePlatformOptions"
          [searchable]="false"
          [selectWidth]="'160px'"
          (apply)="onAdTypePlatformChange()">
          <div class="ad-type-content">
            <div class="ad-type-brands-header">
              <div class="ad-type-label-col"></div>
              <div class="ad-type-brands-row">
                <div class="ad-type-brand-chip" *ngFor="let brand of brandNames">
                  <img class="brand-logo-icon" [src]="getBrandLogoUrl(brand)" [alt]="brand">
                  <span>{{ brand }}</span>
                </div>
              </div>
            </div>
            <div class="ad-type-row" *ngFor="let group of filteredAdTypeData">
              <div class="ad-type-label-col">{{ group.label }}</div>
              <div class="ad-type-bars-row">
                <div class="ad-type-bar-cell" *ngFor="let brand of group.brands">
                  <div class="ad-type-bar-track">
                    <div class="ad-type-bar-fill"
                      [style.width.%]="brand.percentage"
                      [style.background-color]="getBrandColor(brand.brandName)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-widget-container>
      </div>
    </div>
  </section>

  <!-- Performance Map -->
  <section class="section">
    <div class="widgets-wrapper">
      <div class="widget-container performance-map">
        <app-ribbon *ngIf="showRibbonsAndBanner"></app-ribbon>
        <app-widget-container
          [title]="'Performance Map'"
          [control]="mapMetricControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="mapMetricOptions"
          [searchable]="false"
          [selectWidth]="'248px'"
          (apply)="onMapMetricChange()">
          <div class="chart-area map-area">
            <highcharts-chart
              [Highcharts]="HighchartsMap"
              [constructorType]="'mapChart'"
              [options]="mapChartOptions"
              style="width: 100%; display: block;">
            </highcharts-chart>
          </div>
          <div class="map-legend-row">
            <div class="map-legend-item">
              <span class="map-legend-label">Lower Than Competitors</span>
            </div>
            <div class="map-legend-scale">
              <div class="map-scale-bar">
                <span class="map-scale-stop" style="background:#7B2D8E"></span>
                <span class="map-scale-stop" style="background:#5246B5"></span>
                <span class="map-scale-stop" style="background:#3068A8"></span>
                <span class="map-scale-stop" style="background:#28989E"></span>
                <span class="map-scale-stop" style="background:#50C8A0"></span>
                <span class="map-scale-stop" style="background:#8DD680"></span>
                <span class="map-scale-stop" style="background:#C8DC50"></span>
                <span class="map-scale-stop" style="background:#F0C020"></span>
              </div>
              <div class="map-scale-labels">
                <span>-100%</span>
                <span>-50%</span>
                <span>0%</span>
                <span>+50%</span>
                <span>+100%</span>
              </div>
            </div>
            <div class="map-legend-item">
              <span class="map-legend-label">Higher Than Competitors</span>
            </div>
            <div class="map-legend-item no-data">
              <span class="map-legend-swatch no-data-swatch"></span>
              <span class="map-legend-label">No Data</span>
            </div>
          </div>
        </app-widget-container>
      </div>
    </div>
  </section>

</div>
</div>

<div class="bottom-banner" *ngIf="showRibbonsAndBanner">
  <div class="banner-content">
    <div class="banner-text-title">Unlock Your<br>Social Insights</div>
    <div class="banner-arrows">
      <img [src]="'svg/arrow-vector-green.svg' | assetVersion">
      <img [src]="'svg/arrow-vector-green.svg' | assetVersion">
    </div>
    <div class="banner-text">Compare spend, reach, and creative mix across your brand and competitors</div>
    <div class="banner-arrows">
      <img [src]="'svg/arrow-vector-purple.svg' | assetVersion">
      <img [src]="'svg/arrow-vector-purple.svg' | assetVersion">
    </div>
    <button class="banner-button" (click)="onConnectClick()">Connect Now</button>
  </div>
</div>
